'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoVisaIcon = function LogoVisaIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M5.375 11.875C5.25 11.187 4.812 11 4.25 11H0v.188c2.875.75 5.25 2.313 6.313 5.25zm1.188 6l-.25-1.438c-.563-1.438-1.875-2.813-3.375-3.375L5.001 21h2.75l4.125-10H9.063zM13.875 21L15.5 11h-2.625L11.25 21zm7.063-10.187c-2.563 0-4.375 1.375-4.375 3.313 0 1.438 1.313 2.25 2.25 2.75 1.063.5 1.375.813 1.375 1.25 0 .625-.813.938-1.563.938-1.063 0-1.625-.125-2.438-.5l-.313-.188-.375 2.25c.563.313 1.688.563 2.875.563 2.688 0 4.5-1.375 4.5-3.438 0-1.125-.688-2-2.188-2.75-.875-.438-1.438-.75-1.438-1.188s.5-.875 1.5-.875c.813 0 1.438.125 1.938.375l.25.125.313-2.188a6.565 6.565 0 0 0-2.313-.438zm7 .187c-.625 0-1.125.188-1.375.875L22.688 21h2.75c.438-1.188.563-1.5.563-1.5h3.313l.25 1.5h2.438l-2.063-10zm-1.25 6.5s.25-.625 1.063-2.813c0 0 .188-.625.313-.938l.188.813c.5 2.438.625 2.938.625 2.938h-2.188z' })
    );
};

exports.default = LogoVisaIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/LogoVisaIcon.js
// module id = 639
// module chunks = 0